import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { PhysicalConnectionFlow } from 'sharedComponents/PhysicalConnectionFlow';
import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';
import { IconDrive, IconGenericMachine, IconMotor } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import { apiCallStatus, ASSET_TYPES_MS } from 'helpers/constants';
import { useTranslation } from 'react-i18next';
import { routes } from 'routes';

import './style.scss';

const AssetPhysicalConnectionComponent = (props) => {
    const { t: translate } = useTranslation();
    const physicalConnections = props?.model?.physicalConnections;
    const connectedAssets = physicalConnections?.data?.powertrain?.connectedAssets || [];
    const isGenericMachine = props?.asset?.assetType === ASSET_TYPES_MS.GENERICMACHINE;

    return (
        <div className='asset-details-physical-connection' id='asset-details-physical-connection'>
            <h3 className='physical-connection-title'>{translate('ABB.Powertrain.Frontend.assetDetailsPhysicalConnection')}</h3>
            <div className='physical-connection-content'>
                <LoadingStatusWrapper
                    loadingStatus={physicalConnections?.loadingStatus}
                >
                    {physicalConnections?.loadingStatus !== apiCallStatus.LOADING &&
                        (Array.isArray(connectedAssets) && connectedAssets.length > 0
                            ? <div className='asset-physical-connection' id='asset-physical-connection-id'>
                                <PhysicalConnectionFlow
                                    assets={connectedAssets.map(item => ({
                                        id: item.assetId,
                                        assetName: item.assetName,
                                        assetType: item.assetType,
                                        subType: item.subType || null,
                                        outputSpeedRatio: item.speedRatio || null
                                    }))}
                                    currentAssetId={props?.asset?.id}
                                />
                            </div>
                            : <div className='physical-connection-empty-container' id='physical-connection-empty-container'>
                                <div className='physical-connection-icon' id='physical-connection-icon'>
                                    <IconDrive color={colors.neutralGray} />
                                    <span className='physical-connection-dots' />
                                    <IconMotor color={colors.neutralGray} />
                                    <span className='physical-connection-dots' />
                                    <IconGenericMachine color={colors.neutralGray} />
                                </div>
                                {!isGenericMachine && <div className='physical-connection-empty-state'>
                                    {translate('ABB.Powertrain.Frontend.assetDetailsPhysicalConnectionEmptyState')}
                                </div>}
                                <div className={`physical-connection-text${isGenericMachine ? ' physical-connection-text--spaced' : ''}`} id='physical-connection-text'>
                                    {translate('ABB.Powertrain.Frontend.assetDetailsPhysicalConnectionConfigure')}
                                    <span className='physical-connection-link-container' id='physical-connection-link-container'>
                                        <Link to={{ pathname: routes.ToolsPowertrainConfigurationV2 }} className='physical-connection-link'>
                                            {translate('ABB.Powertrain.Frontend.assetDetailsPhysicalConnectionConfigureLink')}
                                        </Link>
                                    </span>
                                </div>
                            </div>)
                    }
                </LoadingStatusWrapper>
            </div>
        </div>
    );
};

export default AssetPhysicalConnectionComponent;

AssetPhysicalConnectionComponent.propTypes = {
    asset: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        assetType: PropTypes.string
    }),
    model: PropTypes.shape({
        physicalConnections: PropTypes.shape({
            data: PropTypes.shape({
                powertrain: PropTypes.shape({
                    connectedAssets: PropTypes.arrayOf(PropTypes.shape({
                        assetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                        assetName: PropTypes.string,
                        assetType: PropTypes.string,
                        subType: PropTypes.string,
                        speedRatio: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                    }))
                })
            }),
            loadingStatus: PropTypes.string
        })
    })
};
